import React from 'react';
import ListCards from './ListCards';
import Icons from './Icons';

let ListBoards = (props) => {
  if (props.vis !== null){
    let vis = props.vis;
    return (
      <div 
      id={props.tabs.id} 
      key={props.tabs.id} 
      className="tableros-home">
        <div className="tabName">{props.tabs.name}</div>
        <div className="arrow gray"><Icons name="arrowThin"/></div>
        <ul className="visuals-home">
        {Object.keys(vis).map((key) => {
          let card = vis[key].card;
          let priority = card.priority;
          return <ListCards 
          abr={key} 
          card={card} 
          priority={priority} 
          key={vis[key].id} />
        })}
        </ul>
      </div>
    )
  } else {
    return(
      <div>Cargando Tableros</div>
    )
  }
}
export default ListBoards;


// WEBPACK FOOTER //
// ./src/Containers/ListBoards.js